import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ModulesActions from "../../actions/modulesActions";
import * as constants from "../../constants";

const loadModulesLogic = createLogic({
	type: ActionTypes.LOAD_MODULES,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get("/modules")
					.then(res => {
						dispatch(ModulesActions.loadModulesSuccess(res.data));
						done();
					})
					.catch(error => {
						dispatch(ModulesActions.loadModulesFail(error));
						done();
					});
			});
	},
});

export default [loadModulesLogic];
